import { renderAlert } from "../../CommonComponents/Alert/Alert";
import apolloGraphQlClient from "../../GraphQL/DataAccessGraphQLClient.js";
import { FETCH_WORKSPACES } from "../../GraphQL/Queries";
import { PATCH, POST } from "../../service/axiosMethods"
import { ELASTIC_URL } from "../../utils/apiConstant"
import store from "../store";
import ACTION_TYPES from "../types";
import { v4 as uuidv4 } from 'uuid';



export const fetchWorkSpaces = (userFromDb) => async (dispatch) => {
    try {
        const res = await POST(`${ELASTIC_URL}/workspace`, { index: 'workspace', field: "user_id", value: `${userFromDb.email}` })
        let workspaceList = [];
        if (res && res.status == 201) {
            if (res && res.data.length == 0) {
                dispatch({ type: ACTION_TYPES.SET_WORKSPACE_DATA, workspaceListData: [], currentSelectedWorkspace: null })
            }
            else res.data.forEach((workspace) => {
                const workspaces = { index: workspace._index, id: workspace._id, ...workspace._source }
                workspaceList.push(workspaces);
            });
            dispatch({ type: ACTION_TYPES.SET_WORKSPACE_DATA, workspaceListData: workspaceList, currentSelectedWorkspace: workspaceList[0], selectedWorkspaceId: workspaceList[0].id })
        }
    } catch (error) {
        console.log(error)
    }
}

export const createFolder= async(newFolder,parent,workspace)=>{
    const apolloGraphQlClient=(await import('../../GraphQL/DataAccessGraphQLClient.js')).default
    const {CREATE_FOLDER} = await import("../../GraphQL/Queries")
    let newFolderId="f_"+uuidv4()
    let folder={
        id:newFolderId,
        workspace_id:workspace.id,
        l_id:parent ?  parent.l_id+'.'+newFolderId :workspace.id+'.'+newFolderId,
        isParent:false,
        created_date:new Date(),
        updated_date: new Date(),
        user_email:workspace.user_email,
        name:"New folder",
        parent:workspace.id
    }
    const folderVariables = { folder };
    const { folderResponse } = await apolloGraphQlClient.query({ query: CREATE_FOLDER, variables:folderVariables });
}

export const addMember=async(sharedWith,workspace,addedMember,callback)=>{
    const handleuser=async(userToReceive)=>{
    const apolloGraphQlClient=(await import('../../GraphQL/DataAccessGraphQLClient.js')).default;
    const {AddMemberToWorkspace}= await import('../../GraphQL/Queries');
    let accessObj={}
            const {userData}=store.getState().userReducer
            accessObj.id=userToReceive.email+"_"+workspace.id
            accessObj.user_id=userToReceive.email
            accessObj.entity_id=workspace.id
            accessObj.sender_id = userData.email;
            accessObj.view=workspace.name
            accessObj.type = 'Workspace';
            accessObj.compound_object = false;
            accessObj.access_created = new Date(); // Set the timestamp to the current date/time
            accessObj.access_updated = new Date();      
            accessObj.receiver_name=userToReceive.username;   
            accessObj.highlevelaccess='2222';
            accessObj.Read='Full';
            accessObj.Write='Full';
            accessObj.Share='Full';
            accessObj.Delete='Full';
            let newNotification={}
            newNotification.notification_id=uuidv4()
            newNotification.recipient_id = userToReceive.email;
            newNotification.sender_id = userData.email;
            newNotification.receiver_name=userToReceive.username
            newNotification.entity_id=workspace.id
            newNotification.timestamp = new Date(); // Set the timestamp to the current date/time
            newNotification.notification_type = addedMember?'Member Added':'Add Member';
            newNotification.status = 'Not read';
            newNotification.view = workspace.name;
            newNotification.accesslevel = 'Full';
            newNotification.message='';
            let metaData={
                workspace_id:workspace.workspace_id,workspaceName:workspace.name,userEmail:workspace.user_email,username:userData.name,type:'Workspace',
                ...(addedMember && {
                    addedMemberEmail: addedMember.email,
                    addedMemberUsername: addedMember.username
                })
            }
            newNotification.metadata=JSON.stringify(metaData)

        let AddMemberDto={
            workspace_id:workspace.id,
            notification:newNotification,
            access:accessObj
        }
        let addMemberVariable = {
            member: AddMemberDto
          };
        
    const response = await apolloGraphQlClient.mutate({mutation:AddMemberToWorkspace,variables:addMemberVariable}) 
    if(response && response.data){
        
        if(response.data.addMemberToWorkspace.success){
            if(addedMember){
                renderAlert('Other Members notified successfully','success',2000)
                return true;
            }else{
            renderAlert('Member added to workspace successfully','success',2000)
            callback(userToReceive)
            return true;}
            //dispatch notification and access to store
        }else{
            renderAlert('Failed to add member','error',2000)
            return false;
        }
    }
}
    for(const userToReceive of sharedWith)
    {
        await handleuser(userToReceive);
    }
}



export const removeMember=(accessId,callback)=>async()=>{
    try{
        const responseAccess=await POST(`access/deleteAccess/`,{access_id:accessId});
        if(responseAccess.status===201){
            callback()
        }
    }catch(error){
        console.log('Error in revoking access')
    }
}

export const removeMemberNotification=async(receiver,workspace)=>{
    const {userData}=store.getState().userReducer
    let newNotification={}
            newNotification.notification_id=uuidv4()
            newNotification.recipient_id = receiver.email;
            newNotification.sender_id = userData.email;
            newNotification.receiver_name=receiver.username
            newNotification.entity_id=workspace.id
            newNotification.timestamp = new Date(); // Set the timestamp to the current date/time
            newNotification.notification_type = 'Delete Member';
            newNotification.status = 'Not read';
            newNotification.view = workspace.name;
            newNotification.accesslevel = null;
            newNotification.message='';
            let metaData={
                workspace_id:workspace.workspace_id,workspaceName:workspace.name,userEmail:workspace.user_email,username:userData.name,
            }
            newNotification.metadata=JSON.stringify(metaData)
            const response = await POST(`/notification/register/`,newNotification);
            if(response.status===201){
                renderAlert('Access Revoked successfully and User notified','success',2000)
            }

}

export const fetchFolderByParent=async (parent)=>{
    const apolloGraphQlClient=(await import('../../GraphQL/DataAccessGraphQLClient.js')).default
    const {FETCH_FOLDER} = await import("../../GraphQL/Queries")
    const { data } = await apolloGraphQlClient.query({ query: FETCH_FOLDER, variables:{parent} });
    return data.fetchFolderByParent 
}

export const fetchWorkbookByParent = async (parent) => {
try {
    const res = await POST(`${ELASTIC_URL}/search`, {index:'workbook', field: "parent", value: `${parent}`})
    return res.data
} catch (error) {
    console.log(error)
}
}

export const fetchSheetByParent = async (parent) => {
    try {
        const sheetIndex = window.SHEET_INDEX;

        const res = await POST(`${ELASTIC_URL}/search`, {index:sheetIndex, field: "workspace_id", value: `${parent}`})
        if(res && res.data) return res.data
        else {
            console.log("fetchSheetByParent",res)
            renderAlert('Some problem in fetching sheet','error');
        }
    } catch (error) {
        console.log(error)
    }
    }


export const saveWorkspace = (workspaceInput) => async (dispatch) => {
    try {

        const clonedWorkspace = JSON.parse(JSON.stringify(workspaceInput));

        const {
            id,
            name,
            user_email,
            description,
            created_date,
            updated_date,
            isParent,
            deactivated
        } = clonedWorkspace;

        const workspaceForDB = {
            id,
            name,
            user_email,
            description,
            created_date,
            updated_date,
            isParent,
            deactivated
        };

        const { workspaceListData } = store.getState().workspaceReducer;

        const isUpdate = workspaceListData.some(w => w.id === id);

        const apolloGraphQlClient =
            (await import('../../GraphQL/DataAccessGraphQLClient.js')).default;

        const { CREATE_WORKSPACE } =
            await import("../../GraphQL/Queries");

        const response = await apolloGraphQlClient.query({
            query: CREATE_WORKSPACE,
            variables: { workspace: workspaceForDB }
        });

        if (response?.data?.createWorkspace?.id) {

            let workspaceListCopy = [...workspaceListData];

            if (!isUpdate) {
                workspaceListCopy.push(clonedWorkspace);

                dispatch({
                    type: ACTION_TYPES.SET_WORKSPACE_DATA,
                    rowDataEditor: {
                        action: "addWorkspace",
                        workspace: clonedWorkspace
                    }
                });

                await ShareWorkspaceAccess(clonedWorkspace);

                renderAlert('Workspace added', 'success');
            } else {

                workspaceListCopy = workspaceListCopy.map(w =>
                    w.id === id ? clonedWorkspace : w
                );

                dispatch({
                    type: ACTION_TYPES.SET_WORKSPACE_DATA,
                    rowDataEditor: {
                        action: "renameWorkspace",
                        workspace: clonedWorkspace
                    }
                });

                renderAlert('Workspace updated', 'success');
            }

            dispatch({
                type: ACTION_TYPES.SET_WORKSPACE_DATA,
                workspaceListData: workspaceListCopy,
                selectedWorkspaceId: id,
                currentSelectedWorkspace: clonedWorkspace
            });
        }

    } catch (error) {
        console.log("error in saving workspace", error);
        renderAlert('Error in adding workspace', 'error');
    }
};


export const ShareWorkspace = async(workspace,userToReceive,accessLevel,callback) =>  {
    try {
            let newNotification={}
            const {userData}=store.getState().userReducer
            newNotification.notification_id=uuidv4()
            newNotification.recipient_id = userToReceive.email;
            newNotification.sender_id = userData.email;
            newNotification.entity_id=workspace.id
            newNotification.receiver_name=userToReceive.username
            if(userToReceive.email===userData.email){
                renderAlert("Sheet can't be shared with the same person which is signed In",'error')
                return
            } 
            newNotification.timestamp = new Date(); // Set the timestamp to the current date/time
            newNotification.notification_type = 'Workspace_Shared';
            newNotification.status = 'Not read';
            newNotification.accesslevel = accessLevel;

            let metaData={
                workspace_id:workspace.id,workspaceName:workspace.name,workspace_identifier:workspace.workspace_identifier,username:userData.name,type:'Workspace'
            }
            newNotification.metadata=JSON.stringify(metaData)
            const response = await POST(`/notification/register/`,newNotification);
            if(response.status===201) {    
                callback("success")        
            }
            else{
                callback("error")     
            }
        
    } catch (error) {
        callback(error)     
        console.log("error in sharing Workspace", error);
    }
}

export const ShareWorkspaceAccess = async(workspace,callback) =>  {
    try {
            let accessObj={}
            const {userData}=store.getState().userReducer
            accessObj.id=userData.email+"_"+workspace.id
            accessObj.user_id=userData.email
            accessObj.entity_id=workspace.id
            accessObj.sender_id = userData.email;
            accessObj.receiver_name=userData.name;
            accessObj.type = "Workspace";
            accessObj.compound_object = false;
            accessObj.access_created = new Date(); // Set the timestamp to the current date/time
            accessObj.access_updated = new Date(); 
            let highLevelAccessArr = ["2", "2", "2", "2"]
            accessObj.Write='Full'           
            accessObj.Share='Full'    
            accessObj.Delete='Full'
            accessObj.Read='Full'
            accessObj.highlevelaccess=highLevelAccessArr.join('')
            const response = await POST(`/access/register`,accessObj);
            if(response.status===201)
            if(callback) callback(userToReceive) 

    } catch (error) {    
        console.log("error in adding Workspace", error);
    }
}
export const getMembersOfWorkSpace=async(workspace_id)=>{
    try{
        const apolloGraphQlClient=(await import('../../GraphQL/DataAccessGraphQLClient.js')).default
        const {GetMembersOfWorkSpace} = await import("../../GraphQL/Queries")
        const {data}  = await apolloGraphQlClient.query({ query: GetMembersOfWorkSpace, variables:{workspace_id:workspace_id},fetchPolicy: 'network-only'});
        return data.getMembersOfWorkSpace
    }
    catch(err){

    }
}

export const deleteWorkspace = (workspace_id) => async (dispatch) => {
    try {
        const apolloGraphQlClient = (await import('../../GraphQL/DataAccessGraphQLClient.js')).default
        const { DELETE_WORKSPACE_ITEM } = await import('../../GraphQL/Queries')
        const response = await apolloGraphQlClient.mutate({ mutation: DELETE_WORKSPACE_ITEM, variables: { workspace_id: workspace_id } })

        if (response) {
            const { workspaceListData } = store.getState().workspaceReducer;
            let updatedWorkspaceList = workspaceListData.filter((item) => item.id != workspace_id)


            dispatch({
                type: ACTION_TYPES.SET_WORKSPACE_DATA,
                workspaceListData: updatedWorkspaceList
            });
            renderAlert('Workspace deleted successfully', 'success', 2000)

        }
    }
    catch (err) {
        console.log(err)
        renderAlert('Error Deleting Workspace, Please try again.', 'error', 2000)
    }
}




export const fetchWorkspaceOfAUSer = (userData, setInStore = false) => async (dispatch) => {
    try {
        const workspaceResponse = await apolloGraphQlClient.query({
            query: FETCH_WORKSPACES,
            variables: { user_email: userData.email }
        });

        const fetchedWorkSpaces = workspaceResponse?.data
            ? workspaceResponse.data.fetchWorkSpaces.map(({ __typename, ...rest }) => rest)
            : [];

        if (setInStore) {
            dispatch(setWorkspaceListInStore(fetchedWorkSpaces));
        }

        return fetchedWorkSpaces;
    } catch (error) {
        console.error("Error in fetchWorkspaceOfAUSer", error);
    }
}

export const setWorkspaceListInStore = (updatedWorkspaceListData = []) => async (dispatch) => {
    try {
        const { userWorkspaceList = [] } =
        store.getState().workspaceReducer;

        const workSpaceMap = new Map();

        [...updatedWorkspaceListData, ...userWorkspaceList].forEach(ws => {
            workSpaceMap.set(ws.id, ws);
        });
  
        dispatch({
          type: ACTION_TYPES.SET_WORKSPACE_DATA,
          userWorkspaceList: Array.from(workSpaceMap.values())
        });
    } catch (error) {
        console.error("Error in setWorkspaceListInStore", error);

    }
}